import { useEffect, useState } from 'react';

const MUTE_KEY = 'portal_chime_muted';
let ctx = null;

const getCtx = () => {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  return ctx;
};

// Phones only allow sound after a tap, so unlock audio on the first touch
export const unlockAudio = () => {
  const c = getCtx();
  if (c && c.state === 'suspended') c.resume().catch(() => {});
};

export const isChimeMuted = () => localStorage.getItem(MUTE_KEY) === '1';

export const playChime = (force = false) => {
  if (!force && isChimeMuted()) return;
  const c = getCtx();
  if (!c) return;
  const t0 = c.currentTime + 0.02;
  [[880, 0], [1318.5, 0.14]].forEach(([freq, at]) => {
    const o = c.createOscillator();
    const g = c.createGain();
    o.type = 'sine';
    o.frequency.value = freq;
    g.gain.setValueAtTime(0.0001, t0 + at);
    g.gain.exponentialRampToValueAtTime(0.35, t0 + at + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + at + 0.6);
    o.connect(g).connect(c.destination);
    o.start(t0 + at);
    o.stop(t0 + at + 0.65);
  });
  if (navigator.vibrate) navigator.vibrate([60, 40, 60]);
};

export const useChimeMute = () => {
  const [muted, setMuted] = useState(isChimeMuted());
  const toggle = () => {
    const next = !muted;
    localStorage.setItem(MUTE_KEY, next ? '1' : '0');
    setMuted(next);
    if (!next) { unlockAudio(); playChime(true); }
  };
  return [muted, toggle];
};

// Keep the home-screen icon badge in sync and refresh the bell when a push arrives.
// Sound comes from the phone's own notification (push), per HR's sound settings.
export const useNotificationChime = (unreadCount, refetch) => {
  useEffect(() => {
    if (!navigator.setAppBadge) return;
    (unreadCount > 0 ? navigator.setAppBadge(unreadCount) : navigator.clearAppBadge()).catch(() => {});
  }, [unreadCount]);

  useEffect(() => {
    const unlock = () => unlockAudio();
    document.addEventListener('pointerdown', unlock, { once: true });
    const onMsg = (e) => { if (e.data?.type === 'PUSH_RECEIVED') refetch(); };
    navigator.serviceWorker?.addEventListener('message', onMsg);
    return () => {
      document.removeEventListener('pointerdown', unlock);
      navigator.serviceWorker?.removeEventListener('message', onMsg);
    };
  }, [refetch]);
};
